module.exports = __webpack_public_path__ + "img/设备运维1.f13c04cb.png";